import { getAccessToken } from '@/utils/storage/authStorage'
import { UserProfil } from '../../pages/UserProfil'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/user-profil')({
  component: UserProfil,
  beforeLoad: async () => {
		const accessToken = await getAccessToken()
    if (accessToken === null || accessToken === undefined || accessToken === "") {
      redirect({
        to: '/login',
        throw: true,
        search: { returnTo: "/user-profil" },
      })
    }
	}
})